import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';

import Helper from '@app/helper';
import Preview from '@app/page/transfer/preview';
import PopTip from '@component/info/poptip';

export const File = ({
  action,
  active,
  altText,
  file,
  onClick,
  route,
  showPending,
}) => {
  const title = file.name || file.safename;
  const classNames = ['filelist__item'];
  let extension = Helper.getFileExtension(title);
  if (extension) {
    extension = <span>{extension}</span>;
  }

  let text = I18n.size(file.size, { precision: 0 });

  if (altText && showPending) {
    text = altText;
  }

  let previewKey = null;

  if (Browser.isMobile) {
    if (file.previewable && !active) {
      previewKey = 'transfer.preview.tap_to_open';
    } else if (active) {
      previewKey = 'transfer.preview.now_open';
    }
  }

  if (active) {
    classNames.push('filelist__item--previewing');
  }

  if (onClick) {
    classNames.push('filelist__item--clickable');
  }

  return (
    <li onClick={onClick} className={classNames.join(' ')}>
      <PopTip
        trigger="hover"
        content={<span>{title}</span>}
        key={title}
        offset={10}
        className="filelist__poptip"
      >
        <div className="filelist__meta">
          <span className="filelist__name" title={title}>
            {title}
          </span>
          <p className="filelist__size">
            <span>{text}</span>
            {extension}
          </p>
          {previewKey && (
            <span className="filelist__preview-action">
              {I18n.t(previewKey)}
            </span>
          )}
          {action}
        </div>
      </PopTip>
      {active && Browser.isMobile ? <Preview route={route} /> : null}
    </li>
  );
};

File.propTypes = {
  file: PropTypes.object.isRequired,
  action: PropTypes.node,
  showPending: PropTypes.bool,
  altText: PropTypes.string,
  active: PropTypes.bool,
  onClick: PropTypes.func,
  route: PropTypes.object,
};

const mapStateToProps = ({ route }) => ({ route });

export default connect(
  mapStateToProps,
  null
)(File);
